export enum TypeCDS {
  Lite, //CDS (Compte Drive Seulement) ON/ Sans mail
  Basic,
  Advanced
}

export class TypeCDSString {
  public static Lite = "Google LITE (SSO/ sans mail)";
  public static Basic = "Google BASIC (5Go / mail + IA et Drive limité)";
  public static Advanced = "Google ADVANCED (20Go / Complet)";
}